export default __webpack_public_path__ + "static/media/i008vp.a80c5972.webp";